export default __webpack_public_path__ + "static/media/separator_line.eebf6c0f.svg";